import {MultiSelectClass} from "./MultiSelect";
import React from "react";
import {MultiSelectAdAccountItem} from "./MultiSelectAdAccountItem";
import {MultiSelectSectionItem} from "./MultiSelectSectionItem";
import {MultiSelectChannelNoConnectionItem, MultiSelectChannelNewSeparatelyConnectionItem} from "./MultiSelectChannelNoConnectionItem";
import {CHANNEL_INFO_BY_CHANNEL} from "../channels/channels";
import { withTranslation } from 'react-i18next';
import { ChannelsHelper } from "../channels/channels";
import {PlatformFilter} from "./PlatformFilter";
import {Spinner} from "../Spinner";

class AdAccountsMultiSelectClass extends MultiSelectClass {

    constructor(props) {
        super(props);
        this._getFilteredOrderedLinkedAccounts = this._getFilteredOrderedLinkedAccounts.bind(this);
        this._getFilteredOrderedUnLinkedAccounts = this._getFilteredOrderedUnLinkedAccounts.bind(this);
        this.handlePlatformFilterChange = this.handlePlatformFilterChange.bind(this);
        
        this.state = {
            ...this.state,
            selectedPlatforms: []
        };
    }

    hasToShowItem(item, inputTextValue, showOnlyActive) {
        if (!super.hasToShowItem(item, inputTextValue, showOnlyActive)) {
            return false;
        }
        // Las cuentas ya conectadas también deben respetar los tipos de canal permitidos
        // (showChannelTypes). Sin esto, una cuenta de un canal no soportado como línea de control
        // (ej. Google Search Console / SEO) seguía apareciendo en el selector y se podía agregar.
        const channelInfo = CHANNEL_INFO_BY_CHANNEL[item.channel];
        if (this.props.showChannelTypes && channelInfo && !this.props.showChannelTypes.includes(channelInfo.channelType)) {
            return false;
        }
        return true;
    }

    _getChannelsWithoutConnection() {
        const { channelsAllowed, channelsWithConnection } = this.props.channelsConnections;
        return channelsAllowed.filter(channel => !channelsWithConnection.includes(channel) && (this.props.showChannelTypes.includes(CHANNEL_INFO_BY_CHANNEL[channel]?.channelType)));
    }

    _getChannelsWithOptionsToConnectNewAccounts() {
        const channelsWithOptionsToConnectNewAccounts = ChannelsHelper.getChannelsWithSeparateAccountConnectionOption();
        const { channelsAllowed } = this.props.channelsConnections;
        return channelsAllowed.filter(channel => channelsWithOptionsToConnectNewAccounts.includes(channel) && (this.props.showChannelTypes.includes(CHANNEL_INFO_BY_CHANNEL[channel]?.channelType)));
    }

    _getItemDataMap() {
        return (adAccountData) => {
            return {...adAccountData, id: adAccountData.id.toString()};
        }
    }

    showButtonsFilters() {
        return true;
    }

    handlePlatformFilterChange(selectedPlatforms) {
        this.setState({
            selectedPlatforms: selectedPlatforms
        }, () => {
            this._applyPlatformFilter();
        });
    }

    _applyPlatformFilter() {
        const { selectedPlatforms, inputTextValue, showOnlyActive } = this.state;
        const initialItems = this._getInitialItems();
        
        let filteredItems = initialItems.filter((item) => {
            return this.hasToShowItem(item, inputTextValue, showOnlyActive);
        });

        if (selectedPlatforms.length > 0) {
            filteredItems = filteredItems.filter((item) => {
                return selectedPlatforms.includes(item.channel);
            });
        }

        this.setState({
            filteredItems: filteredItems
        });
    }

    handleFilter(event) {
        const inputTextValue = event.target.value;
        const showOnlyActive = this.state.showOnlyActive;
        const { selectedPlatforms } = this.state;
        const initialItems = this._getInitialItems();
        
        let filteredItems = initialItems.filter((item) => {
            return this.hasToShowItem(item, inputTextValue, showOnlyActive);
        });

        if (selectedPlatforms.length > 0) {
            filteredItems = filteredItems.filter((item) => {
                return selectedPlatforms.includes(item.channel);
            });
        }

        this.setState({
            filteredItems: filteredItems,
            inputTextValue: inputTextValue
        });
    }

    handleOnlyActiveChange(event) {
        const showOnlyActive = event.target.checked;
        const inputTextValue = this.state.inputTextValue;
        const { selectedPlatforms } = this.state;

        if (!showOnlyActive && !this._getInactiveItemsAreLoaded()) {
            this.setState({
                showOnlyActive: showOnlyActive
            }, () => {
                this.props.onLoadInactiveItems();
            });
        }
        else {
            const initialItems = this._getInitialItems();
            let filteredItems = initialItems.filter((item) => {
                return this.hasToShowItem(item, inputTextValue, showOnlyActive);
            });

            if (selectedPlatforms.length > 0) {
                filteredItems = filteredItems.filter((item) => {
                    return selectedPlatforms.includes(item.channel);
                });
            }

            this.setState({
                showOnlyActive: showOnlyActive,
                filteredItems: filteredItems
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.items !== this.props.items) {
            const { selectedPlatforms, inputTextValue, showOnlyActive } = this.state;
            const initialItems = this._getInitialItems();
            
            let filteredItems = initialItems.filter((item) => {
                return this.hasToShowItem(item, inputTextValue, showOnlyActive);
            });

            if (selectedPlatforms.length > 0) {
                filteredItems = filteredItems.filter((item) => {
                    return selectedPlatforms.includes(item.channel);
                });
            }

            this.setState({
                filteredItems: filteredItems
            });
        }
    }

    _getFilteredOrderedLinkedAccounts() {
        return this.state.filteredItems.filter((item) => {
            return item.already_linked;
        });
    }

    _getFilteredOrderedUnLinkedAccounts() {
        return this.state.filteredItems.filter((item) => {
            return !item.already_linked;
        });
    }

    getMultiSelectClassName() {
        return (this.props.longList === true) ? "multi-select-accounts long" : "multi-select-accounts";
    }

    renderAccountsItems(showLinked, showUnlinked) {
        let items = [];
        if(showLinked)
            items = items.concat(this._renderItemsFromFunction(this._getFilteredOrderedLinkedAccounts));
        if(showUnlinked)
            items = items.concat(this._renderItemsFromFunction(this._getFilteredOrderedUnLinkedAccounts));
        return items;

    }

    renderChannelsWithoutConnectionItems() {
        return this._renderItemChannelNoConnection(this._getChannelsWithoutConnection());
    }

    renderChannelsWithOptionsToConnectNewAccounts() {
        return this._renderItemForNewConnectionSeparately(this._getChannelsWithOptionsToConnectNewAccounts());
    }

    renderMultiSelectSectionItem(sectionName) {
        return <MultiSelectSectionItem sectionName={sectionName} />;
    }

    _renderItemsFromFunction(aFunction) {
        const items = aFunction();
        return items.map((item) =>
                <MultiSelectAdAccountItem
                    readOnly={this.props.readOnly}
                    key={`a${item.id}`}
                    accountName={item.name}
                    accountId={item.account_id}
                    channel={item.channel}
                    itemId={item.id}
                    onChange={this.handleChangeItem}
                    checked={this._isSelected(item.id)}
                />
            );
    }

    _renderItemChannelNoConnection(channelsWithoutConnection) {
        return channelsWithoutConnection.map((channel) => (<MultiSelectChannelNoConnectionItem channel={channel} />));
    }

    _renderItemForNewConnectionSeparately(channelsWithoutConnection) {
        return channelsWithoutConnection.map((channel) => (<MultiSelectChannelNewSeparatelyConnectionItem channel={channel} />));
    }

    renderPlatformFilter() {
        return (
            <PlatformFilter
                items={this._getInitialItems()}
                selectedPlatforms={this.state.selectedPlatforms}
                onChange={this.handlePlatformFilterChange}
                channelsConnections={this.props.channelsConnections}
                showChannelTypes={this.props.showChannelTypes}
            />
        );
    }

    renderItems() {
        const { t } = this.props;
        const renderedLinkedAccounts = this.renderAccountsItems(true, false);
        const renderedUnlinkedAccounts = this.renderAccountsItems(false, true);
        const hasBothSections = renderedLinkedAccounts.length > 0 && renderedUnlinkedAccounts.length > 0;
        const renderedLinkedSection = hasBothSections ? this.renderMultiSelectSectionItem(t('agregar_linea_de_control_2_modulo.cuentas_que_el_cliente_ya_utiliza')) : null;
        const renderedUnlinkedSection = hasBothSections ? this.renderMultiSelectSectionItem(t('agregar_linea_de_control_2_modulo.otras_cuentas')) : null;

        return (
            <React.Fragment>
                {this.renderPlatformFilter()}
                <ul key="multi-select-accounts" className={`${this.getMultiSelectClassName()}`}>
                    {renderedLinkedSection}
                    {renderedLinkedAccounts}
                    {renderedUnlinkedSection}
                    {renderedUnlinkedAccounts}
                    {this.renderChannelsWithoutConnectionItems()}
                    {this.renderChannelsWithOptionsToConnectNewAccounts()}
                </ul>
            </React.Fragment>
        );
    }

    render() {
        const { t } = this.props;
        return <div style={{width:"100%", whiteSpace: "nowrap"}}>
            <input key="filter-items" name="filter-items" type="text" onChange={this.handleFilter} style={{...this._getInputTextStyle(), fontSize: '1em', marginBottom: '15px'}} placeholder={t('multiselect.search_placeholder')}/>
            {this.renderRefreshList()}
            {this.renderOnlyActiveCheck()}
            {this.props.isLoadingInactiveItems ? <div className={this.getMultiSelectClassName()} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}><Spinner color="blue"/></div> : this.renderItems()}
            {this.renderButtonsFilters()}
        </div>
    }
}

export const AdAccountsMultiSelect = withTranslation()(AdAccountsMultiSelectClass);
export default AdAccountsMultiSelect;